import * as Yup from 'yup'

export const ApproveSubcontractorRequestsSchema = Yup.object().shape({
  partnerMarketId: Yup.string().required('Market is required'),
})
